import { keepPreviousData, queryOptions } from "@tanstack/react-query";

import { notificacaoLogService } from "@/services/api/NotificacaoLogService";
import { notificacaoRegraService } from "@/services/api/NotificacaoRegraService";
import {
  NotificacaoLogFiltrosCriteria,
  PeriodoResumoNotificacao,
} from "@/types/notificacao-log.type";

const MINUTE = 1000 * 60;
const LIST_STALE = 30 * 1000;
const FILTROS_STALE = 30 * MINUTE;
const RESUMO_STALE = 60 * 1000;

export const notificacoesAdminKeys = {
  logsList: ["notificacoes-admin-logs-listagem"] as const,
  logsFiltros: ["notificacoes-admin-logs-filtros"] as const,
  logsResumo: ["notificacoes-admin-logs-resumo"] as const,
  logsResumoPorCanal: ["notificacoes-admin-logs-resumo-canal"] as const,
  logsDetalheDia: ["notificacoes-admin-logs-detalhe-dia"] as const,
  regras: ["notificacoes-admin-regras"] as const,
};

export const notificacoesAdminQueries = {
  logsList: (criteria: NotificacaoLogFiltrosCriteria) =>
    queryOptions({
      queryKey: [...notificacoesAdminKeys.logsList, criteria],
      queryFn: () => notificacaoLogService.listPaginado(criteria),
      placeholderData: keepPreviousData,
      staleTime: LIST_STALE,
    }),

  logsFiltros: () =>
    queryOptions({
      queryKey: notificacoesAdminKeys.logsFiltros,
      queryFn: () => notificacaoLogService.getFiltros(),
      staleTime: FILTROS_STALE,
    }),

  logsResumo: (dias: PeriodoResumoNotificacao) =>
    queryOptions({
      queryKey: [...notificacoesAdminKeys.logsResumo, dias],
      queryFn: () => notificacaoLogService.getResumo(dias),
      placeholderData: keepPreviousData,
      staleTime: RESUMO_STALE,
    }),

  logsResumoPorCanal: (dias: PeriodoResumoNotificacao) =>
    queryOptions({
      queryKey: [...notificacoesAdminKeys.logsResumoPorCanal, dias],
      queryFn: () => notificacaoLogService.getResumoPorCanal(dias),
      placeholderData: keepPreviousData,
      staleTime: RESUMO_STALE,
    }),

  logsDetalheDia: (dia: string) =>
    queryOptions({
      queryKey: [...notificacoesAdminKeys.logsDetalheDia, dia],
      queryFn: () => notificacaoLogService.getDetalheDia(dia),
      staleTime: RESUMO_STALE,
    }),

  regras: () =>
    queryOptions({
      queryKey: notificacoesAdminKeys.regras,
      queryFn: () => notificacaoRegraService.getMatriz(),
      staleTime: MINUTE,
    }),
};
